<template>
  <div>
    <mz-search-box
      v-for="input of matches"
      :key="input.id"
      :input="input"
      :query-param="queryParam"
      :search-url="searchUrl"
      :placement="placement"
      @change="onChange"
    ></mz-search-box>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import MzShopifySearchBox from './MzShopifySearchBox'
import { setCustomCSS } from '@/helpers'

export default {
  components: { 'mz-search-box': MzShopifySearchBox },
  props: {
    selector: {
      type: String,
      required: false,
      default: 'input[name="q"]'
    },
    searchUrl: {
      type: String,
      required: true
    },
    queryParam: {
      type: String,
      required: false,
      default: 'q'
    },
    placement: {
      type: String,
      required: false,
      default: undefined
    }
  },
  data() {
    return {
      matches: []
    }
  },
  computed: {
    ...mapState('search', ['config'])
  },
  created() {
    setCustomCSS('autocomplete.css', this.config.css)
  },
  mounted() {
    // load suggestions
    const self = this
    setTimeout(() => self.loadAutocomplete(), 200)
  },
  methods: {
    loadAutocomplete() {
      const itemList = document.querySelectorAll(this.selector)
      let inputs = []
      Array.from(itemList).forEach(function(item) {
        inputs.push(item)
      })
      this.matches = inputs
    },
    onChange({ input, value }) {
      input.value = value
    }
  }
}
</script>
